var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cta-button',_vm._g(_vm._b({attrs:{"has-icon":""},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var classes = ref.classes;
return [_c('font-awesome-icon',{class:classes,attrs:{"icon":"pen","fixed-width":"","transform":"shrink-5"}})]}}])},'cta-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.$t('edit')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }